import joyrideHero from '../../../media/software/joyride/gt3rs.jpeg';
import joyride1 from '../../../media/software/joyride/62E1748F-7EE8-4755-A172-87AE4FC383C0_1_105_c.jpeg';
import joyride2 from '../../../media/software/joyride/8F89887C-1C7F-44D1-AAE4-B2023FFA3BD6_1_105_c.jpeg';
import joyride3 from '../../../media/software/joyride/CD9EC5FE-77D0-461B-B782-36C43B64BE40_1_105_c.jpeg';
import joyride4 from '../../../media/software/joyride/F2A866A2-9505-4953-87AF-C74688F01E19_1_105_c.jpeg';

const joyRideData = {
  name: "JoyRide",
  category: "iOS Application",
  tagline: "Navigation app for car enthusiasts that prioritizes the journey",
  duration: "Summer 2024",
  heroImage: joyrideHero,

  description: "[[JoyRide::https://github.com/Madmaxme/JoyRide]] is an iOS navigation app for drivers who prioritize route quality over arrival time. Unlike conventional GPS systems optimized for speed, JoyRide prefers scenic and winding roads. I used the Mapbox SDK to implement custom routing logic that favors curves, elevation changes, and scenic segments. The interface is designed for in-vehicle use with clear map presentation and custom elements that remain readable while driving.",

  techStack: [
    "Swift",
    "iOS Development",
    "Mapbox SDK",
    "Custom Routing Algorithms",
    "UIKit",
    "Core Location",
    "MapKit",
    "Navigation Systems",
    "User Experience Design"
  ],

  gallery: [
    { type: 'image', src: joyride4, alt: 'Apple Maps UI showing the quickest route to San Clemente' },
    { type: 'image', src: joyride1, alt: 'JoyRide interface showing the scenic route by the ocean to San Clemente' },
    { type: 'image', src: joyride3, alt: 'Apple Maps UI showing the quickest route to Chapman University' },
    { type: 'image', src: joyride2, alt: 'JoyRide interface showing route to Chapman University avoiding highways and staying on backroads' }
  ],
  links: {
    github: "https://github.com/Madmaxme/JoyRide",
  },
};

export default joyRideData;
